<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollabel, max-width="800")
    yz-card
      yz-dialog-normal-header(:title="$t('panel.claim_message_template_setup')" @close="closeDialog")

      yz-dialog-normal-content.pa-8
        .text-neutral-700
          .yz-medium-body-sm {{ $t('panel.message_content') }}
          .yz-regular-body-sm {{ $t('panel.message_content_description') }}

          page-editor.mt-4(v-if="showFroala" :parent-form.sync="template")

          .mt-4
            .yz-medium-body-sm {{ $t('panel.insert_smart_fields') }}
            .yz-regular-body-sm {{ $t('panel.smart_fields_description') }}

            .mt-3.d-flex.gap-2.flex-wrap
              yz-chip(v-for="field in smartFields" :key="field.key" link small outlined color="yz-neutral-400" @click="insertSmartField(field.key)")
                span.text-neutral-700 {{ field.label }}

      yz-dialog-normal-actions(:save-label="$t('confirm')" :loading="isSaving" @save="onSave" @cancel="closeDialog")
</template>

<script>
import PageEditor from '@/components/clinic/PageEditor.vue'
import {mapGetters, mapActions} from 'vuex'

export default {
  components: {
    PageEditor
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    parentTemplate: {
      type: String,
      default: null
    },
    claimType: {
      type: String,
      validator: (value) => ['single', 'bulk'].includes(value),
      required: true
    }
  },
  data() {
    return {
      template: null,
      isSaving: false,
      showFroala: false,
      singleClaimSmartFieldKeys: ['panel_name', 'patient_name', 'patient_ic', 'staff_id', 'chit_number', 'claim_number', 'claimed_amount', 'submission_date', 'claim_link', 'mc_days', 'diagnosis', 'medication', 'clinic_name'],
      bulkClaimSmartFieldKeys: ['total_invoices', 'claimed_amount', 'submission_date', 'claim_link', 'clinic_name'],
    }
  },
  mounted() {
    this.template = this.parentTemplate
    this.showFroala = true
  },
  computed: {
    ...mapGetters({company: 'getCompany'}),
    smartFields() {
      if (this.claimType === 'single') {
        return this.allSmartFields.filter(field => this.singleClaimSmartFieldKeys.includes(field.key))
      }
      return this.allSmartFields.filter(field => this.bulkClaimSmartFieldKeys.includes(field.key))
    },
    allSmartFields() {
      return [
        {key: 'panel_name', label: this.$t('panel.panel_name')},
        {key: 'patient_name', label: this.$t('patient_name')},
        {key: 'patient_ic', label: this.$t('panel.patient_nric')},
        {key: 'staff_id', label: this.$t('panel.staff_id')},
        {key: 'chit_number', label: this.$t('panel.chit_number')},
        {key: 'claim_number', label: this.$t('panel.claim_number')},
        {key: 'total_invoices', label: this.$t('panel.total_invoice')},
        {key: 'claimed_amount', label: this.$t('panel.claimed_amount')},
        {key: 'submission_date', label: this.$t('panel.submission_date')},
        {key: 'claim_link', label: this.$t('panel.claim_link')},
        {key: 'mc_days', label: this.$t('panel.mc_days')},
        {key: 'diagnosis', label: this.$t('panel.diagnosis')},
        {key: 'medication', label: this.$t('panel.medication')},
        {key: 'clinic_name', label: this.$t('panel.clinic_name')}
      ]
    },
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    async onSave() {
      this.isSaving = true
      try {
        const fieldName = this.claimType === 'single' ? 'single_claim_message' : 'bulk_claim_message'
        const payload = {
          [fieldName]: this.template
        }

        await this.$axios.patch(`clinics/${this.company.slug}`, payload)
        await this.showMessage(['success', this.$t('message.saved_successfully')])

        this.$emit('saved')
        this.showDialog = false
      } catch (error) {
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isSaving = false
      }
    },
    insertSmartField(fieldKey) {
      let text = ''
      const key = `{{${fieldKey}}}`
      if (this.template) {
        text = `${this.template} ${key}`
      } else {
        text = key
      }
      this.template = text
    }
  }
}
</script>

<style scoped>
</style>